export const ProviderLinks = [
  {
    provider_code: 'kag',
    links: [],
  },
  {
    provider_code: 'spg',
    links: [],
  },
  {
    provider_code: 'jkg',
    links: [],
  },
  {
    provider_code: 'sag',
    links: [],
  },
  {
    provider_code: 'sxy',
    links: [],
    prefix: '9cp',
  },
  {
    provider_code: 'kim',
    links: [],
    prefix: 'k9p',
  },
  {
    provider_code: 'cqf',
    links: [],
  },
  {
    provider_code: 'cq9',
    links: [],
  },
  {
    provider_code: 'nsp',
    links: [],
  },
  {
    provider_code: 'pkg',
    links: [],
  },
  {
    provider_code: 'pgs',
    links: [],
  },
  {
    provider_code: 'pgl',
    links: [],
    prefix: '',
  },
  {
    provider_code: 'ptg',
    links: [],
    prefix: '',
  },
  {
    provider_code: 'ftg',
    links: [],
    prefix: '',
  },
  {
    provider_code: 'big',
    links: [],
  },
  {
    provider_code: 'pmp',
    links: [],
  },
  {
    provider_code: 'spp',
    links: [],
  },
  {
    provider_code: 'wml',
    links: [],
    prefix: 'wml_',
  },
  {
    provider_code: 'alb',
    links: [],
    prefix: '',
  },
  {
    provider_code: 'ryc',
    links: [],
    prefix: '9COONTHB06-',
  },
  {
    provider_code: 'rtg',
    links: [],
    prefix: 'NCP',
  },
  {
    provider_code: 'neg',
    links: [],
    prefix: 'NCP',
  },
  {
    provider_code: 'yeb',
    links: [],
    prefix: '',
  },
  {
    provider_code: 'ezg',
    links: [],
    prefix: '',
  },
  {
    provider_code: 'ezg',
    links: [],
    prefix: '',
  },
  {
    provider_code: 'sx2',
    links: [],
    prefix: '9d1',
  },
  {
    provider_code: 'km2',
    links: [],
    prefix: '9b1',
  },
];
